import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { FaYoutube, FaRegPlayCircle } from 'react-icons/fa';
import { FiArrowUpRight } from 'react-icons/fi';
import kebabCase from 'lodash/kebabCase';

import colors from '../../theme/colors';
import LinkComponent from '../LinkComponent';
import { StyledBlogPost } from './blogPost.styled';
import { getFormattedTime, sliceText, getImageUrl } from '../../helpers';

const BlogPost = ({ title, post_id, post_date, publish_date, category, direction, type, className, video_url, handleVideoOpen }) => {
  const postUrl = video_url || `/post/${post_id}`;
  const date = +(publish_date || post_date);

  return (
    <StyledBlogPost direction={direction} type={type} className={className} imageUrl={getImageUrl({ post_id, video_url, small: true })}>
      <div className="blog-post">
        {
          (
            post_id &&
            <LinkComponent to={postUrl} type={video_url ? 'external' : 'internal'} target={video_url ? '_blank' : '_self'} className="blog-post_image-link" title={title}>
              <div className="blog-post_image-link_image-container">
                <div className="blog-post_image-link_image-container_image-block" />
                {
                  video_url &&
                  <FaRegPlayCircle color="white" className="blog-post_image-link_image-container_video-icon" />
                }
              </div>
            </LinkComponent>
          ) ||
          (
            video_url &&
            <div className="blog-post_image-link blog-post_image-link__video-image" title={title} onClick={() => handleVideoOpen(video_url)}>
              <div className="blog-post_image-link_image-container">
                <div className="blog-post_image-link_image-container_image-block" />
                <FaRegPlayCircle color="white" className="blog-post_image-link_image-container_video-icon" />
              </div>
            </div>
          )
        }
        <div className="blog-post_details-container">
          <div className="blog-post_details-container_category-container">
            {
              type === 'videoLink' ?
                <FaYoutube color={colors.red} /> :
                <FiArrowUpRight color={colors.tycoonMain} />
            }
            <Link to={`/categories/${kebabCase(category)}`} className="blog-post_details-container_category-container_category-name">{category.toUpperCase()}</Link>
            <i>&#8226;</i>
            <time
              dateTime={new Date(date).toISOString()}
              className="blog-post_details-container_category-container_post-time"
            >
              {getFormattedTime(date)}
            </time>
          </div>
          <LinkComponent to={postUrl} type={video_url ? 'external' : 'internal'} target={video_url ? '_blank' : '_self'} title={title} className="blog-post_details-container_text-link">
            <h3>
              {sliceText(title, 65)}
            </h3>
          </LinkComponent>
        </div>
      </div>
    </StyledBlogPost>

  );
};

BlogPost.propTypes = {
  post_id: PropTypes.string,
  title: PropTypes.string.isRequired,
  post_date: PropTypes.string,
  publish_date: PropTypes.string,
  category: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['post', 'videoLink']),
  direction: PropTypes.oneOf(['row', 'column']),
  url: PropTypes.string
};

BlogPost.defaultProp = {
  id: 'id',
  title: 'Blog Post',
  date: Date.now(),
  popular: false,
  category: 'Blog Category',
  direction: 'row',
  type: 'post'
};

export default BlogPost;
